import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { incrementAsync, decrementAsync, fetchCounter } from '../redux/slices/counterSlice';

export default function Counter() {
    const dispatch = useAppDispatch();
    const value = useAppSelector((state) => state.counter.value);
    const loading = useAppSelector((state) => state.counter.loading);

    useEffect(() => {
        dispatch(fetchCounter());
    }, [dispatch]);

    return (
        <div className="counter">
            <h1>Счетчик</h1>
            <div className="counter-display">{value}</div>
            <div className="counter-buttons">
                <button onClick={() => dispatch(decrementAsync())} disabled={loading}>
                    -
                </button>
                <button onClick={() => dispatch(incrementAsync())} disabled={loading}>
                    +
                </button>
            </div>
        </div>
    );
}